module.exports = __webpack_public_path__ + "img/icon_kezxvipslt.b307f1a0.png";